export const DEFAULT_DATE = new Date(1991, 6, 16, 12, 0)
